// EXEMPT
// import { useMemo } from "react";

// import { readState } from "@/__main__/app-state.mjs";
// import {
//   loadPreviousMatchTileAd,
//   setPreviousMatchTileAd,
// } from "@/app/actions.mjs";
// import { GAME_SHORT_NAMES } from "@/app/constants.mjs";
import { GAME_SYMBOL_LOL } from "@/game-lol/definition-symbol.mjs";
import { GAME_SYMBOL_TFT } from "@/game-tft/definition-symbol.mjs";
import { GAME_SYMBOL_VAL } from "@/game-val/definition-symbol.mjs";
// import { deepSearch } from "@/util/deep-search.mjs";
// import gameShortNameReassign from "@/util/delete-me-utility.mjs";
// import { useSnapshot } from "@/util/use-snapshot.mjs";

// const MIN_POS = 2;
// const MAX_POS = 16;

// some games have recap tiles or in case of TFT the match
// tile is 2x the height, in those cases we need to "override" the index
const MAP_GAME_SYMBOL_TO_AD_INDEX = {
  [GAME_SYMBOL_LOL]: 3,
  [GAME_SYMBOL_TFT]: 1,
  [GAME_SYMBOL_VAL]: 2,
};

function useGetMatchTileAdIndex({ _matchList = [], gameSymbol = "ALL" }) {
  // const {
  //   marketing: { previousMatchTileAd },
  // } = useSnapshot(readState);

  // // Running this once will trigger the above snapshot to update.
  // loadPreviousMatchTileAd();

  // const matchTileAdIndex = useMemo(() => {
  //   if (!matchList.length) return;

  //   /* every game has their match IDs somewhere else 🥴 */
  //   const matchPropertyRegex = /^matchId|^gameId|^apexId|^id$/i;

  //   const matchIds = matchList.map((match) =>
  //     deepSearch(match, matchPropertyRegex),
  //   );

  //   const previousMatchTileAdByGame =
  //     previousMatchTileAd?.[gameShortNameReassign(GAME_SHORT_NAMES[gameSymbol])];
  //   const previousIndex = matchIds.indexOf(previousMatchTileAdByGame);
  //   const matchIndex =
  //     /* if the index of the previous match tile ad is >= MAX_POS, go back to default position MIN_POS & increment prio */
  //     previousIndex <= 0 || previousIndex >= MAX_POS ? MIN_POS : previousIndex;
  //   const matchTileAdId = matchIds[matchIndex];

  //   if (matchTileAdId && previousMatchTileAdByGame !== matchTileAdId) {
  //     setPreviousMatchTileAd(
  //       gameShortNameReassign(GAME_SHORT_NAMES[gameSymbol]),
  //       matchTileAdId,
  //     );
  //   }

  //   return matchIndex;
  // }, [matchList, previousMatchTileAd]);

  const matchTileAdIndex = MAP_GAME_SYMBOL_TO_AD_INDEX[gameSymbol] ?? 2;

  return matchTileAdIndex;
}

export default useGetMatchTileAdIndex;
